import { TabLines, TabLinesProps, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

import { StreamFilterTabs } from './StreamTypeTabLine';

export const StyledTabLines = styled(TabLines)<TabLinesProps<StreamFilterTabs>>`
  [data-tab-header] {
    margin-left: -20px;
    margin-right: -20px;
    padding: 0 20px;
    border-bottom: solid 1px var(--border-default);
  }

  [data-tab] {
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }
  }

  [data-tab-button] {
    white-space: nowrap;
    ${typographyV2.uiSm};
    padding: 8px 4px;
  }
`;
